import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.radioButtons = this.element.querySelectorAll('input[name="move_licences"]');
    this.unlinkAll = this.element.querySelector("#unlink_all");
    this.deleteAccount = this.element.querySelector("#delete_account");

    if (!this.deleteAccount) return;

    this.onModeChange = this.onModeChange.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);

    this.radioButtons.forEach((radio) => radio.addEventListener("change", this.onModeChange));
    this.unlinkAll?.addEventListener("change", this.onCheckboxChange);
    this.deleteAccount.addEventListener("change", this.onCheckboxChange);

    this.syncState();
  }

  disconnect() {
    this.radioButtons?.forEach((radio) => radio.removeEventListener("change", this.onModeChange));
    this.unlinkAll?.removeEventListener("change", this.onCheckboxChange);
    this.deleteAccount?.removeEventListener("change", this.onCheckboxChange);
  }

  onModeChange() {
    this.syncState();
  }

  onCheckboxChange(event) {
    if (this.selectedMode() !== "copy") return;

    if (event.currentTarget === this.unlinkAll && this.unlinkAll.checked) {
      this.deleteAccount.checked = false;
    }
    if (event.currentTarget === this.deleteAccount && this.deleteAccount.checked) {
      this.unlinkAll && (this.unlinkAll.checked = false);
    }
  }

  syncState() {
    const mode = this.selectedMode();

    if (this.unlinkAll) {
      this.unlinkAll.checked = false;
      this.unlinkAll.disabled = false;
    }
    this.deleteAccount.checked = false;

    if (mode === "move") {
      this.deleteAccount.disabled = true;
      return;
    }

    this.deleteAccount.disabled = false;
  }

  selectedMode() {
    return this.element.querySelector('input[name="move_licences"]:checked')?.value;
  }
}
